"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanelMenu = exports.PanelMenuItems = void 0;
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
exports.PanelMenuItems = [
    { value: 'routes', label: 'Routes' },
    { value: 'dialogs', label: 'Dialogs' }
];
function getLabel(value) {
    var _a;
    return ((_a = exports.PanelMenuItems.find(item => item.value === value)) === null || _a === void 0 ? void 0 : _a.label) || '';
}
const PanelMenu = (props) => {
    const { value, onChange } = props;
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const label = (0, react_1.useMemo)(() => getLabel(value), [value]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Button, { size: 'small', endIcon: react_1.default.createElement(core_1.Icon, null, "arrow_drop_down"), onClick: (event) => {
                setAnchorEl(event.currentTarget);
            } }, label),
        react_1.default.createElement(core_1.Menu, { keepMounted: true, id: 'panel-menu', open: !!anchorEl, anchorEl: anchorEl, onClose: () => setAnchorEl(null) }, exports.PanelMenuItems.map(item => (react_1.default.createElement(core_1.MenuItem, { key: item.value, selected: item.value === value, onClick: () => {
                onChange === null || onChange === void 0 ? void 0 : onChange(item.value);
                setAnchorEl(null);
            } }, item.label))))));
};
exports.PanelMenu = PanelMenu;
exports.default = exports.PanelMenu;
//# sourceMappingURL=PanelMenu.js.map